// App.tsx — корень SPA. SessionProvider грузит /api/me; Gate решает: спиннер
// (loading), экран входа (нет сессии) или маршрутизированное приложение.
// Маршруты = 8 экранов мокапа под общим AppLayout; неизвестный путь → на «Сегодня».

import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import type { Capability } from './api/client';
import { SessionProvider, useSession } from './auth/session';
import AppLayout from './components/AppLayout';
import Access from './pages/Access';
import Analytics from './pages/Analytics';
import Builder from './pages/Builder';
import Login from './pages/Login';
import Manage from './pages/Manage';
import Report from './pages/Report';
import Schedule from './pages/Schedule';
import Today from './pages/Today';
import Week from './pages/Week';

// Capability-гард маршрута (Ф8): нет права → на «Сегодня». Это UX-зеркало
// серверной авторизации (прямой переход по URL не должен показывать чужой экран).
function Protected({ cap, children }: { cap: Capability; children: ReactElement }) {
  const { can } = useSession();
  return can(cap) ? children : <Navigate to="/" replace />;
}

function Gate() {
  const { me, loading } = useSession();

  if (loading) {
    return <div className="boot">Загрузка…</div>;
  }
  if (!me) {
    return <Login />;
  }

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Today />} />
        <Route path="week" element={<Week />} />
        <Route path="report" element={<Report />} />
        <Route path="report/:runId" element={<Report />} />
        <Route
          path="analytics"
          element={
            <Protected cap="analytics">
              <Analytics />
            </Protected>
          }
        />
        <Route
          path="builder"
          element={
            <Protected cap="editSurveys">
              <Builder />
            </Protected>
          }
        />
        <Route
          path="schedule"
          element={
            <Protected cap="editSchedule">
              <Schedule />
            </Protected>
          }
        />
        <Route
          path="access"
          element={
            <Protected cap="manageAccess">
              <Access />
            </Protected>
          }
        />
        <Route
          path="manage"
          element={
            <Protected cap="manageRespondents">
              <Manage />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <SessionProvider>
      <Gate />
    </SessionProvider>
  );
}
